var exLists = {
  novel: {
    putonghua: [
      {
        name: '水哥',
        enName: 'x_xiaoxi',
        type: '普通话',
        photo: 'hongshu.png',
        language: 'intp65',
        tag: '推荐',
        desc: '稳重磁性',
        text: '可遇不可求的事，后海有树的院子，夏代有工的玉，此时此刻的云，二十来岁的你。'
      },
      {
        name: '万叔',
        enName: 'x_wanshu',
        type: '普通话',
        photo: 'hongshu.png',
        language: 'intp65',
        tag: '推荐',
        desc: '浑厚磁性',
        text: '草在结它的种子，风在摇它的叶子，我们站着，不说话，就十分美好。'
      },
      {
        name: '逍遥子',
        enName: 'x_xiaohou',
        type: '普通话',
        photo: 'hongshu.png',
        language: 'intp65',
        tag: '推荐',
        desc: '亲和时尚',
        text: '黑夜给了我黑色的眼睛，我却用它寻找光明。'
      },
      {
        name: '宁宁',
        enName: 'x_ningning',
        type: '普通话',
        photo: 'xiaoyu.png',
        photoType: 'type2',
        language: 'intp65',
        tag: '推荐',
        desc: '甜美可爱',
        text: '床前明月光，疑是地上霜。举头望明月，低头思故乡。'
      },
      {
        name: '小雪',
        enName: 'x_xiaoxue',
        type: '普通话',
        photo: 'dengziqi.png',
        language: 'intp65',
        tag: '推荐',
        desc: '成熟知性',
        text: '你站在桥上看风景，看风景的人在楼上看你。明月装饰了你的窗，你装饰了别人的梦。'
      },
      {
        name: '一萍',
        enName: 'x_yiping',
        type: '普通话',
        photo: 'dengziqi.png',
        language: 'intp65',
        desc: '温柔知性',
        text: '公元前我们还太小，公元后我们又太老，没有谁见过，那一次真正美丽的微笑。'
      },
      {
        name: '小媛',
        enName: 'x_xiaoyuan',
        type: '普通话',
        photo: 'dengziqi.png',
        language: 'intp65',
        desc: '亲和自然',
        text: '这本书的作者是来自于Harvard University的 Stephen curry，Stephen curry在他的书中提出了一种LSTM模型，这个LSTM模型很好的解释了wave-particle duality 现象。'
      },
      {
        name: '刚哥',
        enName: 'x_xiaozhang',
        type: '普通话',
        photo: 'hongshu.png',
        language: 'intp65',
        desc: '成熟亲和',
        text: '从前的日色变得慢，车，马，邮件都慢，一生只够爱一个人。'
      },
      {
        name: '小魏',
        enName: 'x_xiaowei',
        type: '普通话',
        photo: 'hongshu.png',
        language: 'intp65',
        desc: '成熟亲和',
        text: '你从远方来，我到远方去，遥远的路程经过这里。天空一无所有，为何给我安慰。'
      },
      {
        name: '晓婧',
        enName: 'x_jinger',
        type: '普通话',
        photo: 'dengziqi.png',
        language: 'intp65',
        desc: '亲切自然',
        text: '我的志愿是做一个校长，每天收集了学生的学费之后就去吃火锅。今天吃麻辣火锅，明天吃酸菜鱼火锅，后天吃猪骨头火锅。'
      },
      {
        name: '小萍',
        enName: 'aisxping',
        type: '普通话',
        photo: 'dengziqi.png',
        language: 'intp65',
        desc: '温柔知性',
        text: '我们都是好朋友吧，所以你的东西就是我的东西，我的东西还是我的东西。'
      },
      {
        name: '许小宝',
        enName: 'aisbabyxu',
        photo: 'xiaoyu.png',
        photoType: 'type2',
        language: 'intp65',
        desc: '童真可爱',
        text: '如果没有任意门、没有时光机、没有竹蜻蜓、没有记忆面包，如果只是一只简单的讲义气的机器猫。'
      }
    ],
    other: [
      {
        name: '小梅',
        enName: 'x_xiaomei',
        photo: 'dengziqi.png',
        language: 'intp65',
        tag: '广东话',
        desc: '亲和自然',
        text: '每个人嘅一生中总回将自己的秘密封锁喺心入面，倘若有一个人，手握住一把钥匙，去开启你嘅心锁，咁佢就应该系你嘅真命天子。'
      },
      {
        name: 'Catherine',
        enName: 'x_catherine',
        photo: 'twpt.png',
        photoType: 'type2',
        language: 'intp65',
        tag: '英文',
        desc: '成熟亲和',
        text: 'If I can see you after a long year, how can I greet?'
      },
      {
        name: 'john',
        enName: 'x_john',
        photo: 'lizhengchun.png',
        language: 'intp65',
        tag: '英文',
        desc: '亲和磁性',
        text: 'If you reveal your secrets to the wind you should not blame.'
      }
    ]
  },
  news: [
    {
      name: '一萍',
      enName: 'x_yiping',
      type: '普通话',
      photo: 'dengziqi.png',
      language: 'intp65',
      tag: '推荐',
      desc: '温柔知性',
      text: '大湖之北，绝艳江城，楚文化独领风骚数百年。我们相信，先祖祝融最终浴火而生，化为神鸟凤凰，飞登九天。奔流不息的时间长河，终将这一刹那，冲刷成永恒，铭刻在这里。'
    },
    {
      name: '小魏',
      enName: 'x_xiaowei',
      type: '普通话',
      photo: 'hongshu.png',
      language: 'intp65',
      tag: '推荐',
      desc: '成熟亲和',
      text: '我们探索着勾践剑无与伦比的浩瀚风景，也探索着先人无与伦比的智慧，这是时代进步，科技进步赋予我们的机遇，让我们能从另一个维度解读国宝，窥见历史。'
    },
    {
      name: '小媛',
      enName: 'x_xiaoyuan',
      photo: 'dengziqi.png',
      language: 'intp65',
      tag: '推荐',
      desc: '亲和自然',
      text: '当一个伟大的时代来临的时候，其实有很多的小人物，都在兢兢业业地做好着自己应该做的事情，当我们每一个人都能把自己所承载的工作做到最好的时候，这个时代，一定是一个伟大的时代。'
    },
    {
      name: '马叔',
      enName: 'x_laoma',
      photo: 'lnns.png',
      photoType: 'type2',
      language: 'intp65',
      tag: '推荐',
      desc: '和蔼亲和',
      text: '每一座博物馆都是民族文化基因的宝库，每一件文物的生命轨迹都让人为之叹服。'
    },
    {
      name: '小薛',
      enName: 'x_xiaoxue_daqi',
      photo: 'dengziqi.png',
      language: 'intp65',
      desc: '甜美自然',
      text: '广厦千间，夜眠仅需六尺；家财万贯，日食不过三餐！这是巨变的中国，人和食物，比任何时候走的更快。'
    },
    {
      name: '虫虫',
      enName: 'x_chongchong',
      photo: 'dengziqi.png',
      language: 'intp65',
      desc: '温柔甜美',
      text: '不管是否情愿，生活总在催促我们迈步向前，人们整装，启程，跋涉，落脚，停在哪里，哪里就会燃起灶火。从个体生命的迁徙，到食材的交流运输，从烹调方法的改变，到人生命运的流转，人和食物的匆匆脚步，从来不曾停歇。'
    },
    {
      name: '许久',
      enName: 'aisjiuxu',
      photo: 'hongshu.png',
      language: 'intp65',
      desc: '亲切自然',
      text: '在中国大陆和宝岛台湾之间，一片浩浩淼淼的水域，如繁星般洒落着千礁百岛，海阔潮涌，天风吹梦。这就是福建平潭。'
    },
    {
      name: '水哥',
      enName: 'x_xiaoxi',
      photo: 'hongshu.png',
      language: 'intp65',
      desc: '稳重磁性',
      text: '小麦，曾经改变人类文明进程的作物，拥有世界上广泛的种植面积，从最日常的馒头、面条、锅盔，到肉夹馍、羊肉泡，再到花样百出的各色小吃，共同奠定了陕西这个面食王国难以撼动的基石。'
    }
  ],
  humancomputer: [
    {
      name: 'Catherine',
      enName: 'x_catherine',
      photo: 'twpt.png',
      photoType: 'type2',
      language: 'intp65',
      tag: '英文',
      desc: '成熟亲和',
      text: 'If I can see you after a long year, how can I greet?'
    },
    {
      name: '小师',
      enName: 'x_xiaoshi_cts',
      photo: 'dengziqi.png',
      language: 'intp65',
      tag: '推荐',
      desc: '甜美亲和',
      text: '仰望星空，地球是宇宙给人类的礼物；低头凝望，一花一叶，是大自然给世界的礼物。'
    },
    {
      name: '小丸子',
      enName: 'x_xiaowanzi',
      photo: 'nannan.png',
      language: 'intp65',
      tag: '推荐',
      desc: '活泼可爱',
      text: '兰州人都说，自己的早晨是从一碗牛肉拉面开始的，这个有着一千多家拉面馆的城市，每天要消耗一百万碗拉面。'
    },
    {
      name: '小光',
      enName: 'x_xiaoguan',
      photo: 'hongshu.png',
      language: 'intp65',
      tag: '推荐',
      desc: '饱满活泼',
      text: '你一会看我，一会看云，你看我时很远，你看云时很近。'
    },
    {
      name: '小媛',
      enName: 'x_xiaoyuan',
      photo: 'dengziqi.png',
      language: 'intp65',
      tag: '推荐',
      desc: '亲和自然',
      text: '你来人间一趟，你要看看太阳，和你的心上人，一起走在大街上。'
    },
    {
      name: '楠楠',
      enName: 'x_nannan',
      photo: 'nannan.png',
      language: 'intp65',
      desc: '活泼可爱',
      text: '我希望童年快乐，找到亲爱的小伙伴，和她在泥坑里跳来跳去。'
    },
    {
      name: '许小宝',
      enName: 'aisbabyxu',
      photo: 'xiaoyu.png',
      photoType: 'type2',
      language: 'intp65',
      desc: '童真可爱',
      text: '幸福是什么，幸福就是猫爱吃鱼，狗爱吃肉，奥特曼爱打小怪兽。'
    },
    {
      name: '水哥',
      enName: 'x_xiaoxi',
      photo: 'hongshu.png',
      language: 'intp65',
      desc: '稳重磁性',
      text: '可遇不可求的事，后海有树的院子，夏代有工的玉，此时此刻的云，二十来岁的你。'
    },
    {
      name: '春春',
      enName: 'x_chunchun',
      photo: 'dengziqi.png',
      language: 'intp65',
      desc: '温柔甜美',
      text: '原来有些东西，没有就是没有，不行就是不行，我却还以为世间的一切，都该有商量的余地。'
    },
    {
      name: '晓婧',
      enName: 'x_jinger',
      photo: 'dengziqi.png',
      language: 'intp65',
      desc: '亲切自然',
      text: '我的志愿是做一个校长，每天收集了学生的学费之后就去吃火锅。今天吃麻辣火锅，明天吃酸菜鱼火锅，后天吃猪骨头火锅。'
    }
  ]
}

export { exLists }



// WEBPACK FOOTER //
// ./src/js/config/read_solution_exlist.js